import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {ErrorBoundary} from '@sentry/react';
import {StepHeader} from 'src/components/step-header';
import {ACCESS_RIGHTS, useAdminAccessRight} from 'src/hooks/access-rights';
import {useEventTracking} from 'src/hooks/useEventTracking';
import {ErrorPage} from 'src/modules/error-page/error-page.components';

import {StickyElement} from '@pb/kit-component-sticky-element';


import {
    createUser,
    createUserHeader,
    createUserTitle,
} from '../../create-user/create-user.module.styl';

import {AttendeeBulkImport} from './attendees-bulk-import';
import {BULK_IMPORT_USERS_STEPS, STEP_TITLE, TOOL_NAME} from './constants';
import {selectBulkUserImportStep} from './services/add-attendees-bulk.slice';
import {UploadFileControls} from './steps/upload-file-step/upload-file-controls';
import {ValidateFileControls} from './steps/validate-file-step/validate-file-controls';

export const AddAttendees = () => {
    const step = useSelector(selectBulkUserImportStep);
    const {hasAccess} = useAdminAccessRight();
    const {bulkOpen} = useEventTracking();

    useEffect(() => {
        bulkOpen({toolName: TOOL_NAME});
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (!hasAccess(ACCESS_RIGHTS.CONFERENCE_EDIT)) {
        return <ErrorPage subtitle="Contact your manager." title="Access denied"/>;
    }

    return (
        <ErrorBoundary>
            <div className={createUser}>
                <StickyElement className={createUserHeader}>
                    <div className={createUserTitle}>
                        <StepHeader title="User Import" subTitle={STEP_TITLE[step]}/>
                        {step === BULK_IMPORT_USERS_STEPS.UPLOAD_FILE &&
                            <UploadFileControls/>}
                        {step === BULK_IMPORT_USERS_STEPS.VALIDATE_FILE &&
                            <ValidateFileControls/>}
                    </div>
                </StickyElement>
                <AttendeeBulkImport/>
            </div>
        </ErrorBoundary>
    );
};
